import ReducerConstants from "../../config/ReduxConstant";

const INITIAL_STATE = {}

export const dashboardData = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state
    }
}